import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import * as $ from "jquery";
import {on, Options} from "../utils/decorators";
import { Gmap, Bounds, LatLng, Marker, MarkerOptions } from "../utils/map-types";
import { mapStyles } from "../utils/map-styles";


@Options({
    template: false,
    ui: {
        mapContainer:    "[data-js-ui=google-map-container]",
        mapItems:        "[data-js-ui=map-item]",
        itemContent:     "[data-js-ui=item-content]",
        shuttleIcon:     "[data-js-shuttle-icon]",
        parkAndRideIcon: "[data-js-park-and-ride-icon]",
    }
})
export default class GoogleMapView extends Marionette.View<Backbone.Model> {

    _map: Gmap;
    _bounds: Bounds;
    _markers: Marker[];
    _zoomLevel = 10;
    _maxZoomLevel = 15;
    _minZoomLevel = 8;
    _markerOptions: MarkerOptions;
    _currentVenue: string;
    _iconVenueSrc = `${window.DJANGO.staticUrl}imgs/icon-map-hb.svg`;
    _iconShuttleBowlSrc = $(this.ui.mapContainer).data('shuttle-icon') ? $(this.ui.mapContainer).data('shuttle-icon') : `${(window as any).DJANGO.staticUrl}imgs/icon-shuttle-bowl.svg`;
    _iconShuttleParkSrc = $(this.ui.mapContainer).data('park-and-ride-icon') ? $(this.ui.mapContainer).data('park-and-ride-icon') : `${(window as any).DJANGO.staticUrl}imgs/icon-shuttle-park.svg`;


    onRender() {
        this._markers = [];
        this._map = this.createMap();
        google.maps.event.addListenerOnce(this._map, "idle", this.onMapIdle.bind(this));
    }

    onMapIdle() {
        this._bounds = new google.maps.LatLngBounds();
        this.centerMap();
        this.addMarkers();
    }

    createMap(): Gmap {
        const options = {
            zoom: this._zoomLevel,
            scrollWheel: false,
            styles: (mapStyles as any),
        };

        const map = new google.maps.Map(this.ui.mapContainer.get(0), options);

        return map;
    }

    centerMap() {
        const lat = this.$el.data("js-lat");
        const lng = this.$el.data("js-lng");
        const name = this.$el.data("js-name");
        const icon = {
            url: this._iconVenueSrc,
            scaledSize: new google.maps.Size(73, 47),
        }
        const markerOptions = {
            map: this._map,
            lat: lat,
            lng: lng,
            icon: icon,
            title: name,
        };
        const venueLocation = new google.maps.LatLng(lat, lng);

        this._map.setCenter({lat: lat, lng: lng});
        this.addMarker(markerOptions);

        google.maps.event.trigger(this._map, "resize");
    }

    addMarker(options: any):Marker {
        if(!_.isNumber(options.lat) || !_.isNumber(options.lng)) {
            return;
        }
        const position = new google.maps.LatLng(options.lat, options.lng);
        const markerObject = $.extend(options, { position: position });
        const marker = new google.maps.Marker(markerObject);

        this._bounds.extend(marker.getPosition());
        this._map.fitBounds(this._bounds);

        marker.addListener("click", this.onMarkerClick.bind(this, marker));
        this._markers.push(marker);
    }

    addMarkers() {
        _.each(this.ui.mapItems, (el, index, els) => {
            let $el = $(el);
            let lat = $el.data('js-lat');
            let lng = $el.data('js-lng');
            let name = $el.data('js-name');
            let type = $el.data('js-icon-type');
            let iconSrc = (type === "BOWLSHUTTLE") ?
            this._iconShuttleBowlSrc : this._iconShuttleParkSrc;
            let icon = {
                url: iconSrc,
                scaledSize: new google.maps.Size(21, 29),
            }
            let markerOptions = {
                lat: lat,
                lng: lng,
                title: name,
                icon: icon,
                map: this._map,
                cID: index,
            }
            this.addMarker(markerOptions);
        });

        google.maps.event.addListenerOnce(
            this._map, 'bounds_changed',
            this.onBoundsChanged.bind(this));
    }

    onMarkerClick(marker: any) {
        const order = marker.cID;

        if (order > -1) {
            this.scrollToAccordion(order);
        };
    }

    scrollToAccordion(order) {
        const body = $("html, body");
        const target = this.ui.mapItems.eq(order);

        this.ui.mapItems.removeClass("is-active");
        this.ui.itemContent.slideUp(0);

        const offset = target.offset().top - target.height() / 2;
        body.animate({ scrollTop: offset }, 500);

        target.addClass("is-active")
            .find(this.ui.itemContent)
            .slideDown(300);
    }

    onBoundsChanged() {
        this._map.setZoom(this._map.getZoom() - 1);
        if (this._map.getZoom() > this._maxZoomLevel) {
            this._map.setZoom(this._maxZoomLevel);
        } else if (this._map.getZoom() < this._minZoomLevel) {
            this._map.setZoom(this._minZoomLevel);
        }
        this._map.fitBounds(this._bounds);
    }

    removeAllMarkers() {
       for(let marker of this._markers) {
           marker.setMap(null);
       }

       this._markers = [];
    }

    onDestroy() {
        this.removeAllMarkers();
    }
}



// WEBPACK FOOTER //
// ./@modules/views/google-maps-view.ts